export default async function EditTopPlanApi(
  id,
  title,
  description,
  target,
  targetDate,
  assignTo,
  positionId,
  approverId,
  attributes,
  strategyId,
  finalized,
  isActive,
  ehrmEvalId,
  ehrmGoalTypeId,
  ehrmGoalWeightage,
  cascadeFromSplitPlans,
  isPercentageUpdate,
  isNegativeScale
) {
  let res = "";
  try {
    const body = {
      id: id,
      title: title,
      description: description || "",
      target: target,
      targetDate: targetDate || "",
      assignTo: assignTo,
      positionId: positionId,
      approverId: approverId,
      attributes: attributes,
      strategyId: strategyId || null,
      finalized: Boolean(finalized),
      isActive: Boolean(isActive),
    };

    // Only add EHRM fields if they have values
    if (ehrmEvalId !== undefined) {
      body.ehrmEvalId = ehrmEvalId;
    }
    if (ehrmGoalTypeId !== undefined) {
      body.ehrmGoalTypeId = ehrmGoalTypeId;
    }
    if (ehrmGoalWeightage !== undefined) {
      body.ehrmGoalWeightage = ehrmGoalWeightage;
    }

    // Add cascade from split plans field
    if (cascadeFromSplitPlans !== undefined) {
      body.cascadeFromSplitPlans = cascadeFromSplitPlans;
    }

    // Add percentage update fields
    if (isPercentageUpdate !== undefined) {
      body.isPercentageUpdate = isPercentageUpdate;
    }

    // Add negative scale field
    if (isNegativeScale !== undefined) {
      body.isNegativeScale = isNegativeScale;
    }

    console.log('EditTopPlanApi - Request Body:', JSON.stringify(body, null, 2));

    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/top-level-plan`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
        console.log(response);
      })
      .catch((error) => {
        console.error("Error editing top level plan: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
